import { SchemaForm } from './SchemaForm'

export default SchemaForm
